export const getSkillTypeName = (names?: string[]): string => {
  if (!names) return '';
  if (!names?.length) return '';
  return [...new Set(names)]?.join(', ');
};
